import React from "react";
import Svg, { Path, ClipPath, Defs, G, Rect } from "react-native-svg";

const CrossIcon = ({ width = 24, height = 24, color = "#000528" }) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      preserveAspectRatio="xMidYMin meet"
    >
      <G clip-path="url(#clip0_1489_3448)">
        <Path
          d="M16.8708 5.50551L12 10.3764L7.1291 5.50551C6.91379 5.2902 6.62178 5.16925 6.31729 5.16925C6.0128 5.16925 5.72078 5.2902 5.50548 5.50551C5.29017 5.72081 5.16921 6.01283 5.16921 6.31732C5.16921 6.62181 5.29017 6.91383 5.50548 7.12913L10.3763 12L5.50548 16.8709C5.29017 17.0862 5.16921 17.3782 5.16921 17.6827C5.16921 17.9872 5.29017 18.2792 5.50548 18.4945C5.72078 18.7098 6.0128 18.8308 6.31729 18.8308C6.62178 18.8308 6.91379 18.7098 7.1291 18.4945L12 13.6236L16.8708 18.4945C17.0861 18.7098 17.3782 18.8308 17.6826 18.8308C17.9871 18.8308 18.2792 18.7098 18.4945 18.4945C18.7098 18.2792 18.8307 17.9872 18.8307 17.6827C18.8307 17.3782 18.7098 17.0862 18.4945 16.8709L13.6236 12L18.4945 7.12913C18.7098 6.91383 18.8307 6.62181 18.8307 6.31732C18.8307 6.01283 18.7098 5.72081 18.4945 5.50551C18.2792 5.2902 17.9871 5.16925 17.6826 5.16924C17.3782 5.16925 17.0861 5.2902 16.8708 5.50551Z"
          fill={color}
        />
      </G>
      <Defs>
        <ClipPath id="clip0_1489_3448">
          <Rect width="24" height="24" fill="white" />
        </ClipPath>
      </Defs>
    </Svg>
  );
};

export default CrossIcon;
